import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "./Login";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      {done ? (
        <div className="text-center" data-testid="forgot-success">
          <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto mb-4" aria-hidden="true" />
          <h1 className="font-heading text-2xl font-bold tracking-tight mb-2">Check your inbox</h1>
          <p className="text-sm text-muted-foreground">If an account exists for {email}, a reset link has been sent.</p>
          <Button asChild className="mt-6 rounded-md"><Link to="/login">Back to sign in</Link></Button>
        </div>
      ) : (
        <>
          <div className="overline mb-2">Account recovery</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Reset password</h1>
          <p className="text-sm text-muted-foreground mb-6">We'll email you a secure reset link.</p>
          {error && <div className="mb-4 text-sm text-destructive" data-testid="forgot-error">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="mt-1.5 rounded-md" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full rounded-md">
              {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" aria-hidden="true" />}
              Send reset link
            </Button>
          </form>
          <p className="mt-6 text-sm text-muted-foreground text-center">
            <Link to="/login" className="font-medium text-foreground underline">Back to sign in</Link>
          </p>
        </>
      )}
    </AuthShell>
  );
}
